class MFRTestimonialQuotes {
  constructor(index, element) {
    this.$index = index
    this.$element = $(element)
    this.$carousel = '.carousel__slides'
    this.$quoteTriggers = '.quote-slide'
  
    this.options = {
      wrapAround: true,
      prevNextButtons: false,
      adaptiveHeight: true,
      pageDots: true,
      selectedAttraction: 0.1,
      friction: 0.55,
      cellAlign: 'center'
    }

    this.init()
  }

  init() {
    $(document).ready(this.slider.bind(this))
    this.$element.find(this.$quoteTriggers).on('click', this.selectSlide.bind(this))
  }

  slider(event) {
    this.$element.find(this.$carousel).flickity(this.options)
    this.changeSlide()
  }

  selectSlide(event) {
    let $currentSlide = $(event.currentTarget)
    let currentIndex = Number( $currentSlide.data('index') )
    
    $currentSlide.siblings().removeClass('is-selected')
    $currentSlide.addClass('is-selected')
    this.$element.find(this.$carousel).flickity('select', currentIndex)
  }

  changeSlide(event) {
    this.$element.find(this.$carousel).on('change.flickity', (event, index) => {
      this.$element.find(this.$quoteTriggers).eq(index).siblings().removeClass('is-selected')
      this.$element.find(this.$quoteTriggers).eq(index).addClass('is-selected')
    })
  }
}